import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-34ab4290")

_pushScopeId("data-v-34ab4290")
const _hoisted_1 = { class: "position-relative p-5 shadow" }
const _hoisted_2 = { class: "blockquote ps-4" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "\n          quote-icon\n          fas\n          fa-quote-left fa-lg\n          position-absolute\n          text-primary\n        " }, null, -1)
const _hoisted_5 = { class: "blockquote-footer presudo-hidden mt-4" }
const _hoisted_6 = { class: "row client-profile" }
const _hoisted_7 = { class: "col-12 col-md-auto" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = {
  title: "Source",
  class: "quote-source d-inline-block font-style-normal pt-3"
}
const _hoisted_10 = { class: "d-block" }
const _hoisted_11 = { class: "d-block" }
const _hoisted_12 = {
  key: 0,
  class: "d-block position-absolute source-link"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" View on Linkedin ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("blockquote", _hoisted_2, [
      _createVNode("p", _hoisted_3, _toDisplayString(_ctx.body), 1),
      _hoisted_4,
      _createVNode("footer", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("img", {
              src: _ctx.pictureUrl,
              alt: "",
              class: "rounded-circle"
            }, null, 8, ["src"])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("cite", _hoisted_9, [
              _createVNode("span", _hoisted_10, _toDisplayString(_ctx.author), 1),
              _createVNode("span", _hoisted_11, _toDisplayString(_ctx.title), 1),
              (_ctx.type == 'linkedin')
                ? (_openBlock(), _createBlock("span", _hoisted_12, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fab', 'linkedin'],
                      class: "fa-2x me-1",
                      transform: "down-3"
                    }),
                    _createVNode("a", {
                      class: "text-secondary text-link",
                      href: _ctx.url,
                      target: "_blank"
                    }, [
                      _hoisted_13,
                      _createVNode(_component_font_awesome_icon, {
                        icon: "external-link-alt",
                        class: "ms-1",
                        transform: "up-1"
                      })
                    ], 8, ["href"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
})